import { createAction } from 'redux-actions';
import * as C from '../constants';
import { fetchAPI } from '../utils/api';
import { toSnakeCase } from 'utils/collections';
import * as ActionCreators from 'actions/ActionCreators';

export const setBraintreeDropinInstance = createAction(
  C.ACTION_TYPES.PAYMENT_SET_BRAINTREE_DROPIN_INSTANCE,
  (dropinInstance: BrainTreeDropinInstance) => ({ dropinInstance })
);

export const setPublicBraintreeToken = createAction(
  C.ACTION_TYPES.PAYMENT_SET_PUBLIC_BRAINTREE_TOKEN,
  (token: string) => ({ token })
);

export const setPaymentMethod = createAction(
  C.ACTION_TYPES.PAYMENT_SET_METHOD,
  (paymentMethod: PaymentMethod) => ({ paymentMethod })
);

export const setPaymentUserInfo = createAction(
  C.ACTION_TYPES.PAYMENT_SET_USER_INFO,
  (userInfo: PaymentUserInfo) => ({ userInfo })
);

export const setPaymentBillingInfo = createAction(
  C.ACTION_TYPES.PAYMENT_SET_BILLING_INFO,
  (billingInfo: PaymentUserInfo) => ({ billingInfo })
);

export const setPaymentCaptcha = createAction(
  C.ACTION_TYPES.PAYMENT_SET_CAPTCHA,
  (captcha: string) => ({ captcha })
);

export const setPaymentInfo = createAction(
  C.ACTION_TYPES.PAYMENT_SET_INFO,
  (amount: number, paymentType: PaymentType, paymentInfo: PaymentInfo) => ({
    amount,
    paymentType,
    paymentInfo,
  })
);

export const setPaymentResponse = createAction(
  C.ACTION_TYPES.PAYMENT_SET_RESPONSE,
  (response: SSResponse<PaymentSuccessResponse> | null) => ({
    response,
  })
);

export const setSubmitPaymentButtonDisabled = createAction(
  C.ACTION_TYPES.PAYMENT_SET_SUBMIT_BUTTON_DISABLED,
  (disabled: boolean) => ({
    disabled,
  })
);

export const setSubmitButtonLoading = createAction(
  C.ACTION_TYPES.PAYMENT_SET_SUBMIT_BUTTON_LOADING,
  (loading: boolean) => ({
    loading,
  })
);

export const getPublicBrainTreeToken = () => async (dispatch, getState) => {
  const json = await fetchAPI('/payments/token', {
    method: 'GET',
  }).then(r => r.json());
  dispatch(setPublicBraintreeToken(json.token));
};

export const submitPayment = (nonce?: string) => async (dispatch, getState) => {
  // Remove cache for dataItems and shopItems
  ActionCreators.removeCartCacheItems();

  const { payment } = getState();
  const {
    userInfo,
    billingInfo,
    paymentMethod,
    amount,
    paymentType,
    paymentInfo,
    captcha,
  } = payment;
  let url, payload;

  const {
    dialCode: userDialCode,
    phoneNumber: userPhoneNumber,
    ...userInfoProps
  } = userInfo;
  const newUserInfo = {
    ...userInfoProps,
    phoneNumber: userDialCode + userPhoneNumber,
  };

  const {
    dialCode: billingDialCode,
    phoneNumber: billingPhoneNumber,
    ...billingInfoProps
  } = billingInfo;
  const newBillingInfo = {
    ...billingInfoProps,
    phoneNumber: billingDialCode + billingPhoneNumber,
  };

  if (paymentMethod == 'online') {
    url = '/payment/online/submit';
    payload = {
      captcha,
      nonce,
      amount,
      recurring: _getRecurring(paymentType, paymentInfo),
      user_info: toSnakeCase(newUserInfo),
      billing_info: toSnakeCase(newBillingInfo),
      payment_type: paymentType,
      payment_info: paymentInfo,
    };
  } else {
    url = '/payment/offline/submit';
    payload = {
      captcha,
      amount,
      billing_info: toSnakeCase(newBillingInfo),
      payment_type: paymentType,
      payment_info: paymentInfo,
    };
  }
  dispatch(setSubmitButtonLoading(true));
  const resp = await fetchAPI(url, {
    method: 'POST',
    version: '1.2',
    payload,
  });
  let _code;
  if (resp.ok) {
    _code = 'OK';
  }
  const respPayload = { _code, _message: undefined, payload };
  dispatch(setPaymentResponse(respPayload));
  dispatch(setSubmitButtonLoading(false));
};

const _getRecurring = (paymentType: PaymentType, paymentInfo: PaymentInfo) => {
  if (paymentInfo != null) {
    if (paymentType == 'SubscriptionBundlePayment') {
      const { payment_interval } = paymentInfo;
      return payment_interval !== 'trial';
    }
  }

  return false;
};



// WEBPACK FOOTER //
// ./app/actions/PaymentActionCreators.ts